import { useLanguage } from '@/contexts/LanguageContext';

export function DemoHeader() {
  const { t } = useLanguage();

  return (
    <header className="sticky top-0 z-30 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-center px-4 py-3">
        <h1 className="text-lg font-serif font-bold">
          {t('dashboardTitle')}
        </h1>
      </div>
    </header>
  );
}
